import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { UserX, ChevronRight } from 'lucide-react';

const ClientesSemCompraCard = () => {
  const navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api.get('/dashboard/clientes-sem-compra?dias=30')
      .then(res => setClientes(res.data || []))
      .catch(() => setErro(true))
      .finally(() => setLoading(false));
  }, []);

  const acima90   = clientes.filter(c => c.dias_sem_compra > 90).length;
  const entre60e90 = clientes.filter(c => c.dias_sem_compra > 60 && c.dias_sem_compra <= 90).length;
  const ate60     = clientes.filter(c => c.dias_sem_compra >= 30 && c.dias_sem_compra <= 60).length;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-orange-50 rounded-lg flex items-center justify-center">
            <UserX size={16} className="text-orange-500" />
          </div>
          <div>
            <p className="text-sm font-black text-slate-800">Clientes Sem Compra</p>
            <p className="text-xs text-slate-400">Sem pedido nos últimos 30 dias</p>
          </div>
        </div>
        <button onClick={() => navigate('/inteligencia-comercial')}
          className="flex items-center gap-1 text-xs font-black text-[#0A3D73] hover:opacity-70 transition-opacity">
          Ver detalhes <ChevronRight size={11} />
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="w-6 h-6 border-4 border-slate-200 border-t-[#0A3D73] rounded-full animate-spin" />
        </div>
      ) : erro ? (
        <div className="flex items-center justify-center py-6">
          <p className="text-sm text-red-500 font-semibold">Erro ao carregar dados</p>
        </div>
      ) : clientes.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-6 gap-1">
          <p className="text-sm font-black text-green-600">Todos os clientes compraram recentemente</p>
          <p className="text-xs text-slate-400">Nenhum cliente sem pedido nos últimos 30 dias</p>
        </div>
      ) : (
        <div className="px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="flex-1 text-center bg-red-50 border border-red-200 rounded-lg py-3">
              <p className="text-2xl font-black text-red-600">{acima90}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-red-400 mt-0.5">+90 dias</p>
            </div>
            <div className="flex-1 text-center bg-orange-50 border border-orange-200 rounded-lg py-3">
              <p className="text-2xl font-black text-orange-500">{entre60e90}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-orange-400 mt-0.5">60–90 dias</p>
            </div>
            <div className="flex-1 text-center bg-green-50 border border-green-200 rounded-lg py-3">
              <p className="text-2xl font-black text-green-600">{ate60}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-green-400 mt-0.5">30–60 dias</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientesSemCompraCard;
